import { Permission } from 'phoenix/domain';

export enum TaskSearchFlags
{
    All = 0x00000000,
    OpenTasks = 0x00000001,
    CompletedTasks = 0x00000002,
    CancelledTasks = 0x00000004,
    ExpiredTasks = 0x00000008
}

export enum TaskObjectType
{
    Document = 'Document',
    Folder = 'Folder'
}

export interface PhoenixTask {
    TaskId: number,
    TaskType: string,
    TaskStatus: string,
    TaskResult: string,
    DateAssigned: string,
    DateCompleted?: string,
    DateEnded?: string,
    ObjectId: number,
    ObjectType: TaskObjectType,
    ObjectName: string,
    DueDate: string,
    Instructions: string,
    CreatorId: number,
    CreatorName: string,
    AssigneeId?: number,
    AssigneeName: string,
    ExternalAssigneeEmail?: string,
    Embedded: {
        Permissions: Permission[]
    }
    Links: {
        CompleteTaskUri: string,
        UpdateTaskUri: string
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/task.ts